import { Component, OnInit } from '@angular/core';
import {ProjectService} from '../../shared/services/project.service';
import {BlogService} from '../../shared/services/blog.service';
import {ExternalpageService, externalpageTypes, externalpageImageTypes} from '../../shared/services/externalpage.service';
import {ExternalpageOverview} from '../../class/externalpage-overview';
import {DomainService} from '../../shared/services/domain.service';

@Component({
    selector: 'app-page-blog',
    templateUrl: './page-blog.component.html',
    styleUrls: ['./page-blog.component.scss'],
    standalone: false
})
export class PageBlogComponent extends ExternalpageOverview implements OnInit {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public nodes :any = [];

  public view = {
    pageType: externalpageTypes.Blog,
    queryParams: {
      pageSize: 9,
      pageNumber: 1,
      totalItems: 0
    },
    data: <any[]> [],
  }

  /**
   * Constructor
   *
   * @param ExternalpageService externalpageService
   */
  constructor(
    public externalpageService: ExternalpageService,
    protected domain: DomainService
  ) {

    super(externalpageService, domain);
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.loadData();

  }

}
